import { type Api, ApiError, type Chat, type RhemaClient } from "@rhema/client";

/** What opening a chat with a number found. */
export type ByNumber = { kind: "chat"; chat: Chat } | { kind: "not_on_rhema" };

/**
 * Opens the direct chat with whoever has this E.164 number, or your own chat when it is yours.
 * Resolves "not_on_rhema" when the number is not on Rhema, or its owner does not let you find them
 * by it.
 */
export async function chatWithNumber(
  api: Api,
  client: Pick<RhemaClient, "createDirect" | "selfChat">,
  e164: string,
  myPhone: string | null | undefined,
): Promise<ByNumber> {
  if (myPhone && e164 === myPhone) return { kind: "chat", chat: await client.selfChat() };
  try {
    const person = await api.userByPhone(e164);
    return { kind: "chat", chat: await client.createDirect(person.id) };
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) return { kind: "not_on_rhema" };
    throw err;
  }
}
